import React from "react";

const Seo = ({ title, description }) => null;

export default Seo;
